export const enum vehicleConstants {
  // Get Vehicles
  getVehicleRequest = "GET_VEHICLE_REQUEST",
  getVehicleSuccess = "GET_VEHICLE_SUCCESS",
  getVehicleFailure = "GET_VEHICLE_FAILURE",

  // Create Vehicle
  vehicleCreateRequest = "VEHICLE_CREATE_REQUEST",
  vehicleCreateSuccess = "VEHICLE_CREATE_SUCCESS",
  vehicleCreateFailure = "VEHICLE_CREATE_FAILURE",

  // Get Vehicles with params (pagination/search)
  getVehicleParamsRequest = "GET_VEHICLE_PARAMS_REQUEST",
  getVehicleParamsSuccess = "GET_VEHICLE_PARAMS_SUCCESS",
  getVehicleParamsFailure = "GET_VEHICLE_PARAMS_FAILURE",

  // Delete Vehicle
  vehicleDeleteRequest = "VEHICLE_DELETE_REQUEST",
  vehicleDeleteSuccess = "VEHICLE_DELETE_SUCCESS",
  vehicleDeleteFailure = "VEHICLE_DELETE_FAILURE",

  // Toggle Vehicle (status)
  vehicleToggleRequest = "VEHICLE_TOGGLE_REQUEST",
  vehicleToggleSuccess = "VEHICLE_TOGGLE_SUCCESS",
  vehicleToggleFailure = "VEHICLE_TOGGLE_FAILURE",

  // Vehicle view
  vehicleViewRequest = "VEHICLE_VIEW_REQUEST",
  vehicleViewSuccess = "VEHICLE_VIEW_SUCCESS",
  vehicleViewFailure = "VEHICLE_VIEW_FAILURE",
  // Vehicle image upload
  vehicleUploadRequest = "VEHICLE_UPLOAD_REQUEST",
  vehicleUploadSuccess = "VEHICLE_UPLOAD_SUCCESS",
  vehicleUploadFailure = "VEHICLE_UPLOAD_FAILURE",
}
